export enum FlightEntryWindowType {
    AcarsSetPeriod = 'AcarsSetPeriod',
    AcarsPosition = 'AcarsPosition',
    ManualOOOITimes = 'ManualOOOITimes',
    ManualDiversionRecoveryPriority = 'ManualDiversionRecoveryPriority',
    ManualGateInfo = 'ManualGateInfo'
}

export enum FlightPhase {
    Out,
    Off,
    On,
    In
}

export enum RecoveryType {
    Faa,
    Custom
}

export interface FlightDataEntryRequestBase {
    acid: string;
    origin: string;
    regId: string | null;
    departureDateTime: string;
}

type AcarsSetPeriodRequest = FlightDataEntryRequestBase & {
    period: string;
};

type AcarsPositionRequest = FlightDataEntryRequestBase;

type ManualThreeDPIRequest = FlightDataEntryRequestBase & {
    phase: FlightPhase;
    dateTime: string;
};

export type FlightEntryRequest = AcarsSetPeriodRequest | AcarsPositionRequest | ManualThreeDPIRequest;
